import { AnalyticsService } from "./analytics.service";
import * as $ from 'jquery';
var ValidationService = /** @class */ (function () {
    function ValidationService() {
        this.errors = [];
        this.dlFieldsError = [];
    }
    ValidationService.getInstance = function () {
        if (!ValidationService.instance) {
            ValidationService.instance = new ValidationService();
        }
        return ValidationService.instance;
    };
    //
    //
    // FORMS !!!! PLEASE DON'T REMOVE THIS AS THERE ARE A LOT OF FORMS THAT ARE USING THIS FUNCTION ON DEV
    //
    //
    ValidationService.prototype.validateEnterprise = function (fields) {
        var analyticsService = new AnalyticsService();
        var dlFieldsError = [];
        var valid = true;
        var errors = [];
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            var formGroup = $(field).closest('.form__group');
            if (formGroup) {
                $(field).closest('.form__group').removeClass('form__group--error');
            }
            if (!formGroup.hasClass("form__group--hidden")) {
                if (field.classList.contains('form__input--required')) {
                    var type = field.type;
                    if (type == 'checkbox') {
                        var checked = field.checked;
                        if (!checked) {
                            dlFieldsError.push(field.name);
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is required');
                            valid = false;
                        }
                    }
                    else {
                        if (!field.value) {
                            //Analytics - Add the fiel into the log
                            dlFieldsError.push(field.name);
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is required');
                            valid = false;
                        }
                        else if (field.value.charAt(0) == " ") {
                            //Analytics - Add the fiel into the log
                            dlFieldsError.push(field.name);
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is required');
                            valid = false;
                        }
                    }
                }
                //Validate Text Area Field
                if (field.classList.contains('form__textarea--required')) {
                    if (!field.value) {
                        //Analytics - Add the fiel into the log
                        dlFieldsError.push(field.name);
                        var form_group = $(field).closest('.form__group');
                        var label = form_group.find('label').text();
                        form_group.addClass('form__group--error');
                        errors.push(label + ' is required');
                        valid = false;
                    }
                }
                if (field.classList.contains('form__input--contact') && (field.value.length > 0)) {
                    if (field.value) {
                        if (!this.validateContact(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--contact-international')) {
                    if (field.value.length > 0) {
                        this.validateContactInternationalNumber(field);
                    }
                }
                if (field.classList.contains('form__input--areaCode') && (field.value.length > 0)) {
                    if (field.value) {
                        if (!this.validateAreaCode(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--identification')) {
                    if (field.value) {
                        var form_group = $(field).closest('.form__group');
                        if (!this.validateSAIDLessStrict(field) && !form_group.hasClass("form__group--hidden")) {
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push('South African ID number is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--email')) {
                    if (field.value) {
                        if (!this.validateEmail(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--website-address')) {
                    if (field.value) {
                        if (!this.validateWebsiteAddress(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--currency')) {
                    if (field.value) {
                        if (!this.validateCurrency(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--currency2')) {
                    if (field.value) {
                        if (!this.validateCurrency2(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--account')) {
                    if (field.value) {
                        if (!this.validateAccount(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--minmaxLength')) {
                    if (field.value) {
                        if (!this.validateMinMaxLength(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--busReg')) {
                    if (field.value) {
                        var _check = field.value.split('/');
                        var _regValid = true;
                        if (_check.length > 1) {
                            var _valid1 = true;
                            var _valid2 = true;
                            var _valid3 = true;
                            if (_check.length == 3) {
                                var _seg1 = new RegExp('^/d{4}$');
                                var _seg2 = new RegExp('^/d{6}$');
                                var _seg3 = new RegExp('^/d{2}$');
                                if (_seg1.test(_check[0])) {
                                    _valid1 = false;
                                }
                                if (_seg2.test(_check[1])) {
                                    _valid2 = false;
                                }
                                if (_seg3.test(_check[2])) {
                                    _valid3 = false;
                                }
                                if (!_valid1 || !_valid2 || !_valid3) {
                                    valid = false;
                                }
                            }
                            else {
                                _regValid = false;
                            }
                        }
                        else if (field.value.length >= 12) {
                            var _numberCheck = new RegExp('^[0-9]+$');
                            if (!_numberCheck.test(field.value)) {
                                _regValid = false;
                            }
                        }
                        if (!_regValid) {
                            valid = false;
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                        }
                    }
                }
                if ((field.type == 'input') || (field.type == 'textarea')) {
                    var format;
                    if (field.classList.contains('form__input--email')) {
                        format = /[`~!#$%^&*()+=\[\]{};:"\\|,<>\/?]/;
                    }
                    else if (field.classList.contains('form__input--website-address')) {
                        format = /[`~!@#$%^&*()+=\[\]{};"\\|,<>?]/;
                    }
                    else if (field.type == "textarea") {
                        format = /[`~!@#$%^&*()_+=\[\]{};:"\\|<>\/?]/;
                    }
                    else {
                        format = /[`~!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
                    }
                    if (format.test(field.value) && !field.classList.contains('form__input--busReg')) {
                        var form_group = $(field).closest('.form__group');
                        var label = form_group.find('label').text();
                        form_group.addClass('form__group--error');
                        errors.push(label + ' is invalid');
                        valid = false;
                        // Analytics - ensure that the field name is not already in the log
                        if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                            dlFieldsError.push(field.name);
                        }
                    }
                }
            }
        }
        //If we have any errors on client side, trigger analytics to record all fields
        if (dlFieldsError.length) {
            analyticsService.dtmFormFieldsValidationFail(dlFieldsError.join(','));
        }
        return {
            valid: valid,
            errors: errors
        };
    };
    //
    //
    // FORMS
    //
    //
    ValidationService.prototype.validate = function (fields) {
        var analyticsService = new AnalyticsService();
        this.dlFieldsError = [];
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.type != 'hidden') {
                this.validateBlur(field);
                this.errors = [];
            }
        }
        //If we have any errors on client side, trigger analytics to record all fields
        if (this.dlFieldsError.length) {
            analyticsService.dtmFormFieldsValidationFail(this.dlFieldsError.join(','));
        }
    };
    ValidationService.prototype.validateBlur = function (field) {
        var formGroup = field.closest('.form__group');
        this.errors = [];
        if (formGroup) {
            field.closest('.form__group').classList.remove('form__group--error');
            var errorMessage = field.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        }
        if (!formGroup.classList.contains("form__group--hidden")) {
            if ((field.classList.contains('form__input--required')) || (field.classList.contains('form__textarea--required'))) {
                this.validateRequired(field);
            }
            if (field.classList.contains('form__input--initials')) {
                if (field.value.length > 0) {
                    this.validateInitials(field);
                }
            }
            if (field.classList.contains('form__input--contact')) {
                if (field.value.length > 0) {
                    this.validateContactNumber(field);
                }
            }
            if (field.classList.contains('form__input--contact-international')) {
                if (field.value.length > 0) {
                    this.validateContactInternationalNumber(field);
                }
            }
            if (field.classList.contains('form__input--areaCode')) {
                if (field.value.length > 0) {
                    this.validateAreaCode(field);
                }
            }
            if (field.classList.contains('form__input--identification')) {
                if (field.value.length > 0) {
                    this.validateSAIDLessStrict(field);
                }
            }
            if (field.classList.contains('form__input--email')) {
                if (field.value.length > 0) {
                    this.validateEmail(field);
                }
            }
            if (field.classList.contains('form__input--website-address')) {
                if (field.value.length > 0) {
                    this.validateWebsiteAddress(field);
                }
            }
            if (field.classList.contains('form__input--currency')) {
                if (field.value.length > 0) {
                    this.validateCurrency(field);
                }
            }
            if (field.classList.contains('form__input--currency2')) {
                if (field.value.length > 0) {
                    this.validateCurrency2(field);
                }
            }
            if (field.classList.contains('form__input--busReg')) {
                if (field.value.length > 0) {
                    this.validateBusinessRegistrationNumber(field);
                }
            }
            if (field.classList.contains('form__input--account')) {
                if (field.value.length > 0) {
                    this.validateAccountNumber(field);
                }
            }
            if (field.classList.contains('marketing-consent-radio')) {
                var form = field.closest('form');
                if (!this.getDataConsentValue(form, field.name)) {
                    this.dlFieldsError.push(field.name);
                    this.errors.push('This field is required');
                    $(field).closest('.form__group').addClass('form__group--error');
                }
                else {
                    $(field).closest('.form__group').removeClass('form__group--error');
                }
            }
            if ((field.localName === 'input') || (field.type === 'textarea')) {
                var format = void 0;
                if (field.classList.contains('form__input--email')) {
                    format = /[`~!#$%^&*()+=\[\]{};:"\\|,<>\/?]/;
                }
                else if (field.classList.contains('js-date-picker') || field.classList.contains('js-date-picker-full') || field.classList.contains('js-date-picker-today-disabled') || field.classList.contains('js-date-picker-full-today-disabled') || field.classList.contains('js-date-picker-enable-previous-days')) {
                    format = /[`~!#$%^&*()_+=\[\]{};:"\\|,<>?]/;
                }
                else if (field.classList.contains('form__input--website-address')) {
                    format = /[`~!@#$%^&*()+=\[\]{};"\\|,<>?]/;
                }
                else if (field.type === 'textarea') {
                    format = /[`~!@#$%^&*()_+=\[\]{};:"\\|<>\/?]/;
                }
                else {
                    format = /[`~!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
                }
                if (format.test(field.value) && !field.classList.contains('form__input--busReg')) {
                    // analytics - Add the field into the log
                    this.dlFieldsError.push(field.name);
                    var form_group = $(field).closest('.form__group');
                    form_group.addClass('form__group--error');
                    this.errors.push('Please remove special characters');
                }
            }
            this.addErrorMessage(field, this.errors);
        }
    };
    ValidationService.prototype.addErrorMessage = function (pElement, pMessages) {
        var _parent = pElement.closest('.form__group');
        if (_parent) {
            var _errorDiv = _parent.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
            if (pMessages.length > 0) {
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors_1 = document.createElement("ul");
                pMessages.forEach(function (pMessage) {
                    var _error = document.createElement("li");
                    _error.innerHTML = pMessage;
                    _errors_1.appendChild(_error);
                });
                _errorDiv.appendChild(_errors_1);
                if (_parent) {
                    _parent.appendChild(_errorDiv);
                }
            }
        }
    };
    ValidationService.prototype.addError = function (pElement, pMessages) {
        var _parent = pElement.closest('.form__group');
        if (_parent) {
            var _errorDiv = _parent.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
            if (pMessages.length > 0) {
                _parent.classList.add('form__group--error');
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors_2 = document.createElement("ul");
                pMessages.forEach(function (pMessage) {
                    var _error = document.createElement("li");
                    _error.innerHTML = pMessage;
                    _errors_2.appendChild(_error);
                });
                _errorDiv.appendChild(_errors_2);
                if (_parent) {
                    _parent.appendChild(_errorDiv);
                }
            }
            else {
                _parent.classList.remove('form__group--error');
            }
        }
    };
    // 
    // 
    // FORMATTERS
    // 
    //
    ValidationService.prototype.validateRequired = function (field) {
        var type = field.type;
        var valid = true;
        if (type == 'checkbox') {
            var checked = field.checked;
            if (!checked) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This checkbox is required to continue');
                valid = false;
            }
        }
        else if (type == 'number') {
            if (isNaN(field.value)) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field can only accept numbers');
                valid = false;
            }
            else if (field.value.length == 0) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
            else if (field.value.charAt(0) == 0 && (!field.classList.contains("form__input--identification") && !field.classList.contains('form__input--contact') && !field.classList.contains('form__input--areaCode'))) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field can not start with 0');
                valid = false;
            }
        }
        else if (type == "select" || type == "select-one" || type == "select-multiple") {
            if (field.value == "") {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (type == "textarea") {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--identification")) {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--identification--passport")) {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = field.closest('.form__group');
                form_group.classList.add('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--initials")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--account")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--busReg")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--contact")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
            else if (field.value.charAt(0) == ' ') {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field cannot start with spaces');
                valid = false;
            }
            else if (field.value.length < 2) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field requires a minimum of 2 characters');
                valid = false;
            }
        }
        return valid;
    };
    ValidationService.prototype.validateInitials = function (field) {
        var valid = true;
        if (field.value.length < 1) {
            this.errors.push('This field requires a minimum of 1 character');
            valid = false;
        }
        return valid;
    };
    // Validate Contact Number
    ValidationService.prototype.validateContactNumber = function (field) {
        var fieldValue = field.value.trim();
        this.errors = []; // Clear previous errors
        var valid = true;
        // Check if the field value is not empty
        if (fieldValue === '') {
            this.errors.push('Please enter a contact number');
            valid = false;
        }
        else {
            // Condition 1: The contact number must be exactly 10 characters.
            if (fieldValue.length !== 10) {
                this.errors.push('South African contact numbers are 10 digits');
                valid = false;
            }
            // Condition 2: Check for letters
            if (/[a-zA-Z]/.test(fieldValue)) {
                this.errors.push('Please enter only numbers in this field (letters are not allowed)');
                valid = false;
            }
            // Condition 3: Check for special characters
            if (/[^0-9]/.test(fieldValue) && !/[a-zA-Z]/.test(fieldValue)) {
                this.errors.push('No special characters allowed (only digits are permitted)');
                valid = false;
            }
            // Condition 4: The contact number must start with a zero.
            if (!fieldValue.startsWith('0')) {
                this.errors.push('Contact number must start with a zero');
                valid = false;
            }
            // Condition 5: Check for invalid cell phone prefixes
            var invalidCellPhonePrefixes = ['075', '080', '085', '086', '087', '088', '089'];
            // Check if the number starts with any of the invalid prefixes
            if (invalidCellPhonePrefixes.some(function (prefix) { return fieldValue.startsWith(prefix); })) {
                this.errors.push('Invalid cell phone number prefix');
                valid = false;
            }
        }
        // Update the form group based on validity
        var formGroup = $(field).closest('.form__group');
        if (valid) {
            formGroup.removeClass('form__group--error');
        }
        else {
            formGroup.addClass('form__group--error');
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    //End
    ValidationService.prototype.validateContactInternationalNumber = function (field) {
        var valid = true;
        if (field.value.length < 5 || field.value.length > 15) {
            var form_group = field.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('Please enter a valid number');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        if (isNaN(field.value)) {
            var form_group = field.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('Please insert only numbers in this field');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        else if (!this.validateContactInternational(field)) {
            var form_group = field.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('This contact number is invalid');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    ValidationService.prototype.validateAreaCode = function (field) {
        var valid = true;
        if (field.value.length != 4) {
            this.errors.push('A South African area code is 4 digits');
        }
        var areaCode = /^(?!0{4})[0-9]{4}$/g;
        if (!areaCode.test(field.value)) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('This field can only contain numbers');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    ValidationService.prototype.validateBusinessRegistrationNumber = function (field) {
        var _check = field.value.split('/');
        var _regValid = false;
        if (_check.length > 1) {
            var _valid1 = false;
            var _valid2 = false;
            var _valid3 = false;
            if (_check.length == 3) {
                var _seg1 = new RegExp('^[0-9]{4}$');
                var _seg2 = new RegExp('^[0-9]{6}$');
                var _seg3 = new RegExp('^[0-9]{2}$');
                if (_seg1.test(_check[0])) {
                    _valid1 = true;
                }
                if (_seg2.test(_check[1])) {
                    _valid2 = true;
                }
                if (_seg3.test(_check[2])) {
                    _valid3 = true;
                }
                if (_valid1 && _valid2 && _valid3) {
                    _regValid = true;
                }
            }
            else {
                _regValid = false;
            }
        }
        else if (field.value.length >= 12) {
            var _numberCheck = new RegExp('^[0-9]+$');
            if (!_numberCheck.test(field.value)) {
                _regValid = false;
            }
        }
        if ((!_regValid) && (field.value)) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('The format of this business registration number is incorrect');
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return _regValid;
    };
    ValidationService.prototype.validateSAID = function (field) {
        // global variables
        var input = field;
        var correct = true;
        var value = input.value;
        // check length and if its a number
        var validNumber = this.validateIsNumber(value);
        if (value.length !== 13 && !validNumber) {
            correct = false;
        }
        // valid date
        var substringYear = parseInt(value.substring(0, 2));
        var substringMonth = parseInt(value.substring(2, 4));
        var substringDay = parseInt(value.substring(4, 6));
        var tempDate = new Date(substringYear, substringMonth, substringDay);
        var date_day = tempDate.getDate();
        var date_month = tempDate.getMonth();
        var date_fullyear = tempDate.getFullYear();
        if (substringYear !== parseFloat(value.substring(0, 2))) {
            correct = false;
        }
        else if (date_month !== parseFloat(value.substring(2, 4))) {
            correct = false;
        }
        else if (date_day !== parseFloat(value.substring(4, 6))) {
            correct = false;
        }
        // Luhn formula
        var tempTotal = 0;
        var checkSum = 0;
        var multiplier = 1;
        for (var itemp = 0; itemp < 13; ++itemp) {
            tempTotal = parseInt(value.charAt(itemp)) * multiplier;
            if (tempTotal > 9) {
                tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
            }
            checkSum = checkSum + tempTotal;
            multiplier = (multiplier % 2 === 0) ? 1 : 2;
        }
        if ((checkSum % 10) !== 0) {
            correct = false;
        }
        // check if sa id field is valid
        if (!correct) {
            return false;
        }
        return true;
    };
    ValidationService.prototype.validateSAIDLessStrict = function (field) {
        var valid = true;
        if (field.value.length != 13) {
            this.errors.push('South African ID is 13 digits');
        }
        var SAIDRegEx = /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))$/;
        if (!SAIDRegEx.test(field.value)) {
            var form_group = $(field).closest('.form__group');
            if (!form_group.hasClass("form__group--hidden")) {
                var label = form_group.find('label').text();
                form_group.addClass('form__group--error');
                this.errors.push('South African ID number is invalid');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validatePassport = function (field) {
        var valid = true;
        var input = field;
        var passportRegex = new RegExp("^[a-zA-Z0-9]*$");
        if (!passportRegex.test(input.value)) {
            if (field.value) {
                var form_group = field.closest('.form__group');
                form_group.classList.add('form__group--error');
                this.errors.push('The format of this passport number is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateIsNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    ValidationService.prototype.validateCurrency = function (field) {
        var valid = true;
        var validField = true;
        if (field.value.toString().length > 10) {
            validField = false;
        }
        else if (this.validateIsNumber(field.value)) {
            var rgx = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?$/;
            validField = field.value.match(rgx);
        }
        else {
            validField = false;
        }
        if (!validField) {
            if (field.value) {
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('The format of this currency field is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateCurrency2 = function (field) {
        var valid = true;
        var validField = true;
        if (field.value.toString().length > 18) {
            validField = false;
        }
        else if (this.validateIsNumber(field.value)) {
            var rgx = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?$/;
            validField = field.value.match(rgx);
        }
        else {
            validField = false;
        }
        if (!validField) {
            if (field.value) {
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('The format of this currency field is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateContact = function (field) {
        var international = false;
        var domain = window.location.href;
        if (domain.includes('https://preview.standardbank.co.za/southafrica') ||
            domain.includes('http://pwempas1v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://pwempas2v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://uwempas1v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://uwempas2v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://dsbgchop183.standardbank.co.za:8080/southafrica') ||
            domain.includes('https://www.standardbank.co.za')) {
            international = false;
        }
        else {
            international = true;
        }
        if (!international) {
            var is_zero_number_correct = true;
            var num = void 0;
            num = /^0[0-9]\d{8}$/g;
            if (num.test(field.value) === false) {
                is_zero_number_correct = false;
            }
            else {
                is_zero_number_correct = true;
            }
            return is_zero_number_correct;
        }
        else {
            return true;
        }
    };
    ValidationService.prototype.validateContactInternational = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^[0-9]*$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    ValidationService.prototype.validateEmail = function (field) {
        var valid = true;
        var input = field;
        var EmailRegEx = /^([a-zA-Z0-9][-a-zA-Z0-9_\+\.]*[a-zA-Z0-9])@([a-zA-Z0-9][-a-zA-Z0-9\.]*[a-zA-Z0-9]\.(arpa|root|aero|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|africa|capetown|durban|joburg|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|ARPA|ROOT|AERO|BIZ|CAT|COM|COOP|EDU|GOV|INFO|INT|JOBS|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TEL|TRAVEL|AFRICA|CAPETOWN|DURBAN|JOBURG|AC|AD|AE|AF|AG|AI|AL|AM|AN|AO|AQ|AR|AS|AT|AU|AW|AX|AZ|BA|BB|BD|BE|BF|BG|BH|BI|BJ|BM|BN|BO|BR|BS|BT|BV|BW|BY|BZ|CA|CC|CD|CF|CG|CH|CI|CK|CL|CM|CN|CO|CR|CU|CV|CX|CY|CZ|DE|DJ|DK|DM|DO|DZ|EC|EE|EG|ER|ES|ET|EU|FI|FJ|FK|FM|FO|FR|GA|GB|GD|GE|GF|GG|GH|GI|GL|GM|GN|GP|GQ|GR|GS|GT|GU|GW|GY|HK|HM|HN|HR|HT|HU|ID|IE|IL|IM|IN|IO|IQ|IR|IS|IT|JE|JM|JO|JP|KE|KG|KH|KI|KM|KN|KR|KW|KY|KZ|LA|LB|LC|LI|LK|LR|LS|LT|LU|LV|LY|MA|MC|MD|MG|MH|MK|ML|MM|MN|MO|MP|MQ|MR|MS|MT|MU|MV|MW|MX|MY|MZ|NA|NC|NE|NF|NG|NI|NL|NO|NP|NR|NU|NZ|OM|PA|PE|PF|PG|PH|PK|PL|PM|PN|PR|PS|PT|PW|PY|QA|RE|RO|RU|RW|SA|SB|SC|SD|SE|SG|SH|SI|SJ|SK|SL|SM|SN|SO|SR|ST|SU|SV|SY|SZ|TC|TD|TF|TG|TH|TJ|TK|TL|TM|TN|TO|TP|TR|TT|TV|TW|TZ|UA|UG|UK|UM|US|UY|UZ|VA|VC|VE|VG|VI|VN|VU|WF|WS|YE|YT|YU|ZA|ZM|ZW)|([0-9]{1,3}\.{3}[0-9]{1,3}))$/;
        if (!EmailRegEx.test(input.value)) {
            if (field.value) {
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('The format of this email address is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateWebsiteAddress = function (field) {
        var valid = true;
        var input = field;
        var addressRegEx = /[`~!@#$%^&*()+=\[\]{};"\\|,<>?]/;
        if (addressRegEx.test(input.value)) {
            if (field.value) {
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('The format of this webiste address is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateAccountNumber = function (field) {
        var valid = true;
        var accountNumbers = /^[0-9]*$/g;
        var format = /[`~.!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
        if (isNaN(field.value)) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('Please insert only numbers in this field');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        else if (accountNumbers.test(field.value) == false || format.test(field.value) == true) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('This field can only contain numbers');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    ValidationService.prototype.validateAccount = function (field) {
        var account = /^[0-9]*$/;
        if (account.test(field.value)) {
            return true;
        }
        else {
            return false;
        }
    };
    ValidationService.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value;
        }
        else {
            return null;
        }
    };
    ValidationService.prototype.formatBusinessReg = function (event) {
        var _stringLength = parseFloat(event.length);
        var _newLength = (_stringLength - 1);
        var _check = event.substring(_newLength);
        var reg = new RegExp('^[0-9]+$');
        if (reg.test(_check)) {
            if (event.length == 4) {
                event = event += '/';
            }
            else if (event.length == 11) {
                event = event += "/";
            }
            else if (event.length > 14) {
                event = event.substring(0, 14);
            }
        }
        else {
            return event.substring(0, _newLength);
        }
        return event;
    };
    ValidationService.prototype.formatExpression = function (inputText) {
        var _check = inputText.split('/');
        if (_check.length > 1) {
            var _valid1 = true;
            var _valid2 = true;
            var _valid3 = true;
            if (_check.length == 3) {
                var _seg1 = new RegExp('^/d{4}$');
                var _seg2 = new RegExp('^/d{6}$');
                var _seg3 = new RegExp('^/d{2}$');
                if (_seg1.test(_check[0])) {
                    _valid1 = false;
                }
                if (_seg2.test(_check[1])) {
                    _valid2 = false;
                }
                if (_seg3.test(_check[2])) {
                    _valid3 = false;
                }
                if (_valid1 && _valid2 && _valid3) {
                    return inputText;
                }
                else {
                    return '';
                }
            }
            else {
                return '';
            }
        }
        else if (inputText.length >= 12) {
            var _firstcharacters = inputText.substring(0, 4);
            var _secondCharacters = inputText.substring(5, 10);
            var _thirdCharacters = inputText.substring(11, 13);
            return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
        }
        return '';
    };
    //
    //
    // CALCULATOR
    //
    //
    ValidationService.prototype.validateCalculator = function (event, button) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var formValid = true;
        var value = field.value;
        var fieldValue = value.replace(/ /g, '');
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.calculator-form__group').removeClass('calculator-form__error');
        $(field).closest('.calculator-form__group').find('div.calculator-form__error-label').remove();
        // required
        if (required == "true") {
            if (fieldValue.length == 0 || fieldValue == '' || fieldValue == 0) {
                formValid = false;
                if (minimum) {
                    if (maximum) {
                        if (title) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                        }
                        else {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                        }
                    }
                    else {
                        this.validateCalculatorError(event, 'Enter the minimum value of ' + this.formatNumbers(minimum));
                    }
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount');
                }
            }
        }
        // min
        if (minimum > parseFloat(fieldValue)) {
            formValid = false;
            if (title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
            }
            else if (!title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
            }
            else if (!title && !maximum) {
                this.validateCalculatorError(event, 'Enter the minimum value of ' + this.formatNumbers(minimum));
            }
        }
        // max
        if (maximum > 0) {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
            }
        }
        else {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0');
                }
            }
        }
        // greater than
        if (greaterThan) {
            var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
            if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                formValid = false;
                this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
            }
        }
        // less than
        if (lessThan) {
            var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
            if (fieldsLessThan.length > 1) {
                var amount_1 = 0;
                $(fieldsLessThan).each(function (index) {
                    var valueElement = $(this).val();
                    if (!valueElement) {
                        amount_1 = amount_1 + 0;
                    }
                    else {
                        amount_1 = amount_1 + parseFloat(valueElement);
                    }
                });
                if (parseFloat(fieldValue) >= amount_1) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
            else {
                if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
        }
        return formValid;
    };
    ValidationService.prototype.validateCalculatorError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        var closestGroup = field.closest('.calculator-form__group');
        $(closestGroup).find('.calculator-form__error-label').remove();
        $(closestGroup).addClass('calculator-form__error').append('<div class="calculator-form__error-label">' + message + '</div>');
    };
    //WPBBSA CALCULATOR VALIDATOR FOR ALL FIELDS FOR ANALYTICS
    ValidationService.prototype.validateWpbbsaCalculatorAllFields = function (allFields, button) {
        var _this = this;
        var analyticsService = new AnalyticsService();
        var dlCalculatorFieldsError = [];
        var formValid = true;
        allFields.forEach(function (element) {
            // varaibles
            var field = element;
            var fieldGroup = field.closest('.wpbbsa-calculator-form__group');
            var fieldValue = field.value;
            var fieldAddon = field;
            var required = field.getAttribute('data-validation-required');
            var title = field.getAttribute('data-validation-title');
            var minimum = parseFloat(field.getAttribute('min'));
            var maximum = parseFloat(field.getAttribute('max'));
            var greaterThan = field.getAttribute('data-validation-greater-than');
            var lessThan = field.getAttribute('data-validation-less-than');
            // removeErrors
            $(field).closest('.wpbbsa-calculator-form__group').removeClass('wpbbsa-calculator-form__error');
            $(field).closest('.wpbbsa-calculator-form__group').find('div.wpbbsa-calculator-form__error-label').remove();
            if (fieldGroup && !fieldGroup.classList.contains('wpbbsa-calculator-form__hidden')) {
                // required
                if (required == "true") {
                    if (field.type == "text" || field.type == "select" || field.type == "select-one") {
                        if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                            formValid = false;
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'This field is required', dlCalculatorFieldsError);
                        }
                    }
                    else {
                        if (fieldValue.length == 0) {
                            formValid = false;
                            if (minimum) {
                                if (maximum) {
                                    if (title) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                                    }
                                    else {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                                    }
                                }
                                else {
                                    _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                                }
                            }
                            else {
                                _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                            }
                        }
                    }
                }
                //check date
                if (field.type == "text" && field.classList.contains('form__datepicker')) {
                    if (fieldValue != "" && fieldValue != null) {
                        var date = new Date(fieldValue);
                        if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Incorrect Date', dlCalculatorFieldsError);
                        }
                        else if (date > new Date()) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Cannot use selected date', dlCalculatorFieldsError);
                        }
                    }
                }
                // min
                if (minimum > parseFloat(fieldValue)) {
                    formValid = false;
                    if (title && maximum) {
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                    }
                    else if (!title && maximum) {
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                    }
                    else if (!title && !maximum) {
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                    }
                }
                // max
                if (maximum > 0) {
                    if (maximum < parseFloat(fieldValue)) {
                        formValid = false;
                        if (title) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                        }
                        else {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                        }
                    }
                }
                else {
                    if (maximum < parseFloat(fieldValue)) {
                        formValid = false;
                        if (title) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'The maximum you can insert is 0 ' + title, dlCalculatorFieldsError);
                        }
                        else {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'The maximum you can insert is 0', dlCalculatorFieldsError);
                        }
                    }
                }
                // greater than
                if (greaterThan) {
                    var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                    if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                        formValid = false;
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount greater than the expenses field', dlCalculatorFieldsError);
                    }
                }
                // less than
                if (lessThan) {
                    var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                    if (fieldsLessThan.length > 1) {
                        var amount_2 = 0;
                        $(fieldsLessThan).each(function (index) {
                            var valueElement = $(this).val();
                            if (!valueElement) {
                                amount_2 = amount_2 + 0;
                            }
                            else {
                                amount_2 = amount_2 + parseFloat(valueElement);
                            }
                        });
                        if (parseFloat(fieldValue) >= amount_2) {
                            formValid = false;
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount (expenses may not exceed total income)', dlCalculatorFieldsError);
                        }
                    }
                    else {
                        if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                            formValid = false;
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount (expenses may not exceed total income)', dlCalculatorFieldsError);
                        }
                    }
                }
            }
        });
        //If we have any errors on client side, trigger analytics to record all fields
        if (dlCalculatorFieldsError.length) {
            analyticsService.dtmFormFieldsValidationFail(dlCalculatorFieldsError.join(','));
        }
        return formValid;
    };
    ValidationService.prototype.validateWpbbsaCalculatorErrorAllFields = function (field, message, dlCalculatorFieldsError) {
        if (message === void 0) { message = ''; }
        var closestGroup = field.closest('.wpbbsa-calculator-form__group');
        $(closestGroup).addClass('wpbbsa-calculator-form__error').append('<div class="wpbbsa-calculator-form__error-label">' + message + '</div>');
        // Analytics - ensure that the field name is not already in the log
        if (field.name && dlCalculatorFieldsError.indexOf(field.name) < 0) {
            dlCalculatorFieldsError.push(field.name);
        }
    };
    ValidationService.prototype.validateWpbbsaCalculator = function (field, button) {
        // varaibles
        var fieldGroup = field.closest('.wpbbsa-calculator-form__group');
        var formValid = true;
        var fieldValue = field.value;
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.wpbbsa-calculator-form__group').removeClass('wpbbsa-calculator-form__error');
        $(field).closest('.wpbbsa-calculator-form__group').find('div.wpbbsa-calculator-form__error-label').remove();
        if (fieldGroup && !fieldGroup.classList.contains('wpbbsa-calculator-form__hidden')) {
            // required
            if (required == "true") {
                if (field.type == "text" || field.type == "select" || field.type == "select-one") {
                    if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                        formValid = false;
                        this.validateWpbbsaCalculatorError(field, 'This field is required');
                    }
                }
                else {
                    if (fieldValue.length == 0) {
                        formValid = false;
                        if (minimum) {
                            if (maximum) {
                                if (title) {
                                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                                }
                                else {
                                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                                }
                            }
                            else {
                                this.validateWpbbsaCalculatorError(field, 'Enter an amount');
                            }
                        }
                        else {
                            this.validateWpbbsaCalculatorError(field, 'Enter an amount');
                        }
                    }
                }
            }
            //check date
            if (field.type == "text" && field.classList.contains('form__datepicker')) {
                if (fieldValue != "" && fieldValue != null) {
                    var date = new Date(fieldValue);
                    if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                        this.validateWpbbsaCalculatorError(field, 'Incorrect Date');
                    }
                    else if (date > new Date()) {
                        this.validateWpbbsaCalculatorError(field, 'Cannot use selected date');
                    }
                }
            }
            // min
            if (minimum > parseFloat(fieldValue)) {
                formValid = false;
                if (title && maximum) {
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else if (!title && maximum) {
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
                else if (!title && !maximum) {
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount');
                }
            }
            // max
            if (maximum > 0) {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                    }
                }
            }
            else {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorError(field, 'The maximum you can insert is 0 ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorError(field, 'The maximum you can insert is 0');
                    }
                }
            }
            // greater than
            if (greaterThan) {
                var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                    formValid = false;
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount greater than the expenses field');
                }
            }
            // less than
            if (lessThan) {
                var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                if (fieldsLessThan.length > 1) {
                    var amount_3 = 0;
                    $(fieldsLessThan).each(function (index) {
                        var valueElement = $(this).val();
                        if (!valueElement) {
                            amount_3 = amount_3 + 0;
                        }
                        else {
                            amount_3 = amount_3 + parseFloat(valueElement);
                        }
                    });
                    if (parseFloat(fieldValue) >= amount_3) {
                        formValid = false;
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
                else {
                    if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                        formValid = false;
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
            }
        }
        return formValid;
    };
    ValidationService.prototype.validateWpbbsaCalculatorError = function (field, message) {
        if (message === void 0) { message = ''; }
        var closestGroup = field.closest('.wpbbsa-calculator-form__group');
        $(closestGroup).addClass('wpbbsa-calculator-form__error').append('<div class="wpbbsa-calculator-form__error-label">' + message + '</div>');
    };
    ValidationService.prototype.validateWpbbsaCalculatorEvent = function (event, button) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var fieldGroup = field.closest('.wpbbsa-calculator-form__group');
        var formValid = true;
        var fieldValue = field.value;
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.wpbbsa-calculator-form__group').removeClass('wpbbsa-calculator-form__error');
        $(field).closest('.wpbbsa-calculator-form__group').find('div.wpbbsa-calculator-form__error-label').remove();
        if (fieldGroup && !fieldGroup.classList.contains('wpbbsa-calculator-form__hidden')) {
            // required
            if (required == "true") {
                if (field.type == "text" || field.type == "select" || field.type == "select-one") {
                    if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                        formValid = false;
                        this.validateWpbbsaCalculatorEventError(event, 'This field is required');
                    }
                }
                else {
                    if (fieldValue.length == 0) {
                        formValid = false;
                        if (minimum) {
                            if (maximum) {
                                if (title) {
                                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                                }
                                else {
                                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                                }
                            }
                            else {
                                this.validateWpbbsaCalculatorEventError(event, 'Enter an amount');
                            }
                        }
                        else {
                            this.validateWpbbsaCalculatorEventError(event, 'Enter an amount');
                        }
                    }
                }
            }
            //check date
            if (field.type == "text" && field.classList.contains('form__datepicker')) {
                if (fieldValue != "" && fieldValue != null) {
                    var date = new Date(fieldValue);
                    if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                        this.validateWpbbsaCalculatorError(field, 'Incorrect Date');
                    }
                    else if (date > new Date()) {
                        this.validateWpbbsaCalculatorError(field, 'Cannot use selected date');
                    }
                }
            }
            // min
            if (minimum > parseFloat(fieldValue)) {
                formValid = false;
                if (title && maximum) {
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else if (!title && maximum) {
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
                else if (!title && !maximum) {
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount');
                }
            }
            // max
            if (maximum > 0) {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                    }
                }
            }
            else {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorEventError(event, 'The maximum you can insert is 0 ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorEventError(event, 'The maximum you can insert is 0');
                    }
                }
            }
            // greater than
            if (greaterThan) {
                var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                    formValid = false;
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount greater than the expenses field');
                }
            }
            // less than
            if (lessThan) {
                var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                if (fieldsLessThan.length > 1) {
                    var amount_4 = 0;
                    $(fieldsLessThan).each(function (index) {
                        var valueElement = $(this).val();
                        if (!valueElement) {
                            amount_4 = amount_4 + 0;
                        }
                        else {
                            amount_4 = amount_4 + parseFloat(valueElement);
                        }
                    });
                    if (parseFloat(fieldValue) >= amount_4) {
                        formValid = false;
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
                else {
                    if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                        formValid = false;
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
            }
        }
        return formValid;
    };
    ValidationService.prototype.validateWpbbsaCalculatorEventError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        var closestGroup = field.closest('.wpbbsa-calculator-form__group');
        $(closestGroup).addClass('wpbbsa-calculator-form__error').append('<div class="wpbbsa-calculator-form__error-label">' + message + '</div>');
    };
    ValidationService.prototype.formatNumbers = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    };
    ValidationService.prototype.validateMinMaxLength = function (field) {
        var elementMin, elementMax;
        if (field.getAttribute('minlength')) {
            elementMin = field.getAttribute('minlength');
        }
        if (field.getAttribute('maxlength')) {
            elementMax = field.getAttribute('maxlength');
        }
        if (elementMin) {
            if (field.value.length < elementMin) {
                return false;
            }
        }
        if (elementMax) {
            if (field.value.length > elementMax) {
                return false;
            }
        }
        return true;
    };
    //Custom Validation for reCaptcha
    ValidationService.prototype.validateReCaptcha = function (valid, reCaptchaFormField) {
        var formGroup = reCaptchaFormField.closest('.form__group');
        this.errors = [];
        if (formGroup) {
            reCaptchaFormField.closest('.form__group').classList.remove('form__group--error');
            var errorMessage = reCaptchaFormField.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        }
        if (valid == false) {
            var form_group = reCaptchaFormField.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('This checkbox is required to continue');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (this.dlFieldsError.indexOf("g-recaptcha") < 0) {
                this.dlFieldsError.push("g-recaptcha");
            }
        }
        this.addErrorMessage(reCaptchaFormField, this.errors);
    };
    return ValidationService;
}());
export { ValidationService };



//////////////////
// WEBPACK FOOTER
// ./services/validation.service.ts
// module id = 63
// module chunks = 0